"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUploadingFiles = void 0;

var getUploadingFiles = function getUploadingFiles(state) {
  return state.uploadingFiles.get('files');
};

exports.getUploadingFiles = getUploadingFiles;